// Importing start icon
import { BsFillStarFill } from 'react-icons/bs';

export default function Skills(){
    const data = [
        {
            id: 0,
            name: "HTML"
        },
        {
            id: 1,
            name: "CSS"
        },
        {
            id: 2,
            name: "JavaScript"
        },
        {
            id: 3,
            name: "Python"
        },
        {
            id: 4,
            name: "Django"
        },
        {
            id: 5,
            name: "React"
        },
        {
            id: 6,
            name: "Next JS"
        },
        {
            id: 7,
            name: "Tauri"
        },
    ];

    return(
        <ul className="list-unstyled">
            {data?.map(item => (
                <li key={item.id}>
                    <BsFillStarFill className="starIcon me-2" />
                    {item.name}
                </li>
            ))}
        </ul>
    )
}